

import React, { useState, useRef, useEffect } from 'react';
import { BASE_URL } from '../../../constant/api';
import { Link } from 'react-router-dom';

// Reusable Circular Image Component
const CircularImage = ({ data, bg, id }) => {
    if (!data || !data.category) {
        console.warn('Missing or invalid data:', data);
        return null; // Avoid rendering invalid data
    }

    return (
        <div className="flex flex-col items-center justify-center">
            <Link to={`/category/${data.category}?sub=${data.id}`}>
                <div
                    className={`flex justify-center items-center border-[3px] w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden hover:scale-110 transition-transform ease-in-out duration-300 border-gray-400 hover:border-green-500 ${bg} ${id === String(data.id) ? "scale-110 border-4 border-green-500" : ""
                        }`}
                >
                    <img
                        src={
                            data.image
                                ? data.image.startsWith(BASE_URL)
                                    ? data.image
                                    : `${BASE_URL}${data.image}`
                                : "https://via.placeholder.com/100"
                        }
                        alt={data.name || data.brandname || "Image"}
                        className="w-full h-full object-cover rounded-full p-1"
                    />
                </div>
            </Link>
            <span
                className={`text-center  line-clamp-1 mt-2 text-xs w-24 overflow-hidden text-ellipsis ${id === String(data.id) ? "text-green-500 font-semibold" : ""
                    }`}
            >
                {data.name || `Category ${data.id}`}
            </span>
        </div>
    );
};

// Circular Image List Component
const CircularImageList = ({ data = [], title = 'Categories', bg, id, categoryId }) => {
    const [expanded, setExpanded] = useState(false);
    const [showViewAll, setShowViewAll] = useState(false);
    const containerRef = useRef(null);

    const toggleView = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current) {
                const container = containerRef.current;
                // Check if the container is overflowing horizontally
                const isOverflowing = container.scrollWidth > container.clientWidth;
                setShowViewAll(isOverflowing);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [data]); // Re-check when data changes

    return (
        <>
            <div className={`flex justify-between items-center px-5`}>
                <h2 className="text-2xl md:text-3xl font-semibold mb-4">{title}</h2>
                {showViewAll && (
                    <p
                        onClick={toggleView}
                        className="cursor-pointer text-xl text-brand-text-light hover:text-brand-primary transition duration-500 ease-in-out"
                    >
                        {expanded ? 'Collapse' : 'View All'}
                    </p>
                )}
            </div>
            {data.length === 0 ? (
                <p className="text-start mx-10 text-base text-gray-500 mt-4">No {title} found</p>
            ) : (
                <div
                    ref={containerRef}
                    className={`p-4 transition-all duration-500 ease-in-out 
                        ${expanded
                            ? 'grid grid-cols-4 md:grid-cols-6 lg:grid-cols-10 gap-6'
                            : 'flex overflow-x-auto gap-4'
                        }`}
                >
                    {/* view all (`/category/${categoryId}?sub=all`0) */}
                        {categoryId && (
                            <div className="flex flex-col items-center justify-center cursor-pointer">
                                <Link to={`/category/${categoryId}?sub=all`} className="flex flex-col items-center">
                                    <div
                                        className={`border-[3px] flex justify-center items-center w-16 h-16 md:w-20 md:h-20 p-4 rounded-full bg-gray-100 border-gray-400 hover:border-brand-primary ${id === 'all' || id === null ? 'scale-110 border-4 border-green-500' : ''
                                            }`}
                                    >
                                        <span className="text-center">All</span>
                                    </div>
                                    <span
                                        className={`text-center mt-2 text-xs overflow-hidden text-ellipsis ${id === 'all' || id === null ? 'text-green-500 font-semibold' : ''
                                            }`}
                                    >
                                        View All
                                    </span>
                                </Link>
                            </div>
                        )}


                    {/* Dynamic Categories */}
                    {data.map((d) => (
                        <CircularImage key={d.id} data={d} bg={bg} id={id} />
                    ))}
                </div>
            )}
        </>
    );
};

export default CircularImageList;  